import {Component, OnInit, Input, ChangeDetectorRef, OnDestroy} from '@angular/core';
import { ScrollDispatcher } from '@angular/cdk/scrolling';
import { Subscription } from 'rxjs';

@Component({
  selector: 'oap-menus-treatment',
  templateUrl: './menus-treatment.component.html',
  styleUrls: ['./menus-treatment.component.scss']
})
export class MenusTreatmentComponent implements OnInit, OnDestroy {

  @Input() active: string;

  private subscribeScroll: Subscription;
  public windowTop: number;

  constructor(private scrollDispatcher: ScrollDispatcher, private cf: ChangeDetectorRef) {
      this.windowTop = window.pageYOffset;
  }

  ngOnInit() {
      this.subscribeScroll = this.scrollDispatcher.scrolled().subscribe(x => {
          this.windowTop = window.pageYOffset;
          this.cf.detectChanges();
      });
  }

  ngOnDestroy() {
      this.subscribeScroll.unsubscribe();
  }

}
